import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-MillsAct',
    templateUrl: './MillsAct.component.html',
    styleUrls: ['./MillsAct.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MillsActComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
